import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageWrapper = ({ children }) => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    useEffect(() => {
        // console.log("location.pathname", location.pathname);
        const pathSegments = location.pathname.split('/');
        const lng = pathSegments[1];
        // console.log("lng", lng);

        if (lng && i18n.options.supportedLngs.includes(lng) && lng !== i18n.language) {
            i18n.changeLanguage(lng).then(() => {
                setLoading(false);
            });
        } else if (!i18n.options.supportedLngs.includes(lng)) {
            navigate(`/zh-TW${location.pathname}`, { replace: true });
        } else {
            setLoading(false);
        }
    }, [location, i18n, navigate]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return children;
};

export default LanguageWrapper;
